function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlelo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "769px",
    height: "505px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#8f8f8f",
    d: "M 43.5,-0.5 C 270.833,-0.5 498.167,-0.5 725.5,-0.5C 749.039,2.37368 763.373,15.3737 768.5,38.5C 768.5,181.167 768.5,323.833 768.5,466.5C 763.712,485.956 751.712,498.623 732.5,504.5C 500.167,504.5 267.833,504.5 35.5,504.5C 16.2923,498.626 4.29227,485.96 -0.5,466.5C -0.5,323.833 -0.5,181.167 -0.5,38.5C 5.39996,15.5996 20.0666,2.59959 43.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 40.5,7.5 C 269.5,7.33333 498.5,7.5 727.5,8C 744.346,11.1784 755.18,21.0117 760,37.5C 760.667,180.167 760.667,322.833 760,465.5C 756.202,482.631 745.702,493.131 728.5,497C 498.833,497.667 269.167,497.667 39.5,497C 22.3244,493.158 11.8244,482.658 8,465.5C 7.33333,322.833 7.33333,180.167 8,37.5C 13.0031,20.9904 23.8365,10.9904 40.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#018060",
    d: "M 452.5,83.5 C 531.979,78.973 590.146,111.64 627,181.5C 642.158,216.594 645.825,252.928 638,290.5C 621.716,351.451 583.883,392.618 524.5,414C 475.006,428.501 428.006,422.835 383.5,397C 372.44,388.942 361.107,381.275 349.5,374C 336.864,367.8 323.531,365.8 309.5,368C 299.373,370.159 289.373,372.826 279.5,376C 213.869,385.77 166.036,361.27 136,302.5C 113.574,238.46 129.408,186.294 183.5,146C 211.493,128.421 241.826,122.421 274.5,128C 287.574,131.368 300.574,135.035 313.5,139C 326.745,140.551 339.078,137.884 350.5,131C 361.5,123.333 372.5,115.667 383.5,108C 404.947,95.1309 427.947,86.9643 452.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 300.5,182.5 C 307.167,182.5 313.833,182.5 320.5,182.5C 320.333,215.502 320.5,248.502 321,281.5C 326.425,284.129 331.925,286.629 337.5,289C 334.671,295.483 331.837,301.983 329,308.5C 322.457,305.813 315.957,302.979 309.5,300C 304.766,296.699 301.933,292.199 301,286.5C 300.5,251.835 300.333,217.168 300.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bedfd6",
    d: "M 469.5,183.5 C 463.167,183.5 456.833,183.5 450.5,183.5C 450.5,218.167 450.5,252.833 450.5,287.5C 449.502,252.671 449.168,217.671 449.5,182.5C 456.354,182.176 463.021,182.509 469.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 469.5,183.5 C 469.333,216.168 469.5,248.835 470,281.5C 475.483,283.996 480.983,286.496 486.5,289C 483.796,295.574 480.962,302.074 478,308.5C 471.517,305.671 465.017,302.837 458.5,300C 453.962,296.975 451.296,292.809 450.5,287.5C 450.5,252.833 450.5,218.167 450.5,183.5C 456.833,183.5 463.167,183.5 469.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfdfd",
    d: "M 218.5,206.5 C 250.945,202.82 271.779,216.486 281,247.5C 281.333,260.167 281.667,272.833 282,285.5C 284.911,286.37 287.411,287.87 289.5,290C 286.966,296.234 284.299,302.4 281.5,308.5C 274.672,306.838 268.839,303.505 264,298.5C 262.438,296.043 261.438,293.376 261,290.5C 260.931,276.112 260.264,261.779 259,247.5C 252.011,231.421 239.844,224.921 222.5,228C 206.183,234.313 199.016,246.146 201,263.5C 203.646,273.31 209.48,280.477 218.5,285C 227.395,288.586 236.062,288.086 244.5,283.5C 247.257,288.682 249.757,294.015 252,299.5C 252.781,300.944 252.614,302.277 251.5,303.5C 225.085,313.524 203.585,307.191 187,284.5C 173.404,258.338 177.57,235.505 199.5,216C 205.657,212.255 211.99,209.088 218.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfdfd",
    d: "M 383.5,205.5 C 411.831,204.684 430.831,217.518 440.5,244C 410.3,258.353 379.633,271.853 348.5,284.5C 343.666,279.203 340.833,272.87 340,265.5C 337.729,233.279 352.229,213.279 383.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9d552",
    d: "M 534.5,205.5 C 563.129,205.214 581.962,218.548 591,245.5C 591.667,252.833 591.667,260.167 591,267.5C 590.138,270.949 588.972,274.283 587.5,277.5C 586.277,278.614 584.944,278.781 583.5,278C 578.167,275.333 572.833,272.667 567.5,270C 574.501,250 568.167,236 548.5,228C 538.048,225.724 528.714,227.891 520.5,234.5C 515.482,230.315 510.982,225.649 507,220.5C 506.837,218.613 507.671,217.113 509.5,216C 517.207,210.808 525.54,207.308 534.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a8262",
    d: "M 382.5,227.5 C 394.521,225.195 404.521,228.529 412.5,237.5C 395.409,245.419 378.076,252.752 360.5,259.5C 360.419,243.644 367.752,232.977 382.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfdfc",
    d: "M 493.5,235.5 C 495.564,235.687 497.564,236.187 499.5,237C 504.294,239.231 508.961,241.731 513.5,244.5C 507.255,263.52 513.255,277.354 531.5,286C 542.25,288.237 551.917,286.071 560.5,279.5C 565.518,283.685 570.018,288.351 574,293.5C 574.749,294.635 574.583,295.635 573.5,296.5C 548.962,313.545 525.462,312.212 503,292.5C 489.067,275.331 485.901,256.331 493.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafcfb",
    d: "M 410.5,278.5 C 411.239,278.369 411.906,278.536 412.5,279C 417.061,283.972 421.727,288.805 426.5,293.5C 408.161,309.993 387.828,312.827 365.5,302C 364.643,301.311 363.977,300.478 363.5,299.5C 367.416,294.004 371.082,288.337 374.5,282.5C 385.566,287.908 396.566,287.741 407.5,282C 408.71,280.961 409.71,279.794 410.5,278.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlelo);
export default __webpack_public_path__ + "static/media/alelo.0f6fb9d254c02692763dfe1113ee70c3.svg";
export { ForwardRef as ReactComponent };